/**
 *
 * @param {string} name
 * @returns
 */

import key from "./key"

const url = `app/${key}`

export const LOAD_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_RECORDS_META_DATA_SUCCESS`
export const LOAD_RECORDS_META_DATA = `${url}/LOAD_RECORDS_META_DATA`
export const LOAD_RECORDS_META_DATA_ERROR = `${url}/LOAD_RECORDS_META_DATA_ERROR`
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`

export const LOAD_SALES_DATA = `${url}/LOAD_SALES_DATA`
export const LOAD_SALES_DATA_SUCCESS = `${url}/LOAD_SALES_DATA_SUCCESS`
export const LOAD_SALES_DATA_ERROR = `${url}/LOAD_SALES_DATA_ERROR`

export const CREATE_SALES_DATA = `${url}/CREATE_SALES_DATA`
export const CREATE_SALES_DATA_SUCCESS = `${url}/CREATE_SALES_DATA_SUCCESS`
export const CREATE_SALES_DATA_ERROR = `${url}/CREATE_SALES_DATA_ERROR`

export const UPDATE_SALES_DATA = `${url}/UPDATE_SALES_DATA`
export const UPDATE_SALES_DATA_SUCCESS = `${url}/UPDATE_SALES_DATA_SUCCESS`
export const UPDATE_SALES_DATA_ERROR = `${url}/UPDATE_SALES_DATA_ERROR`

export const UPDATE_EVENT_DATA = `${url}/UPDATE_EVENT_DATA`
export const UPDATE_EVENT_DATA_SUCCESS = `${url}/UPDATE_EVENT_DATA_SUCCESS`
export const UPDATE_EVENT_DATA_ERROR = `${url}/UPDATE_EVENT_DATA_ERROR`

export const LOAD_SALES_TEMP_DATA = `${url}/LOAD_SALES_TEMP_DATA`
export const LOAD_SALES_TEMP_DATA_SUCCESS = `${url}/LOAD_SALES_TEMP_DATA_SUCCESS`
export const LOAD_SALES_TEMP_DATA_ERROR = `${url}/LOAD_SALES_TEMP_DATA_ERROR`

export const CREATE_SALES_TEMP_DATA = `${url}/CREATE_SALES_TEMP_DATA`
export const CREATE_SALES_TEMP_DATA_SUCCESS = `${url}/CREATE_SALES_TEMP_DATA_SUCCESS`
export const CREATE_SALES_TEMP_DATA_ERROR = `${url}/CREATE_SALES_TEMP_DATA_ERROR`

export const UPDATE_SALES_TEMP_DATA = `${url}/UPDATE_SALES_TEMP_DATA`
export const UPDATE_SALES_TEMP_DATA_SUCCESS = `${url}/UPDATE_SALES_TEMP_DATA_SUCCESS`
export const UPDATE_SALES_TEMP_DATA_ERROR = `${url}/UPDATE_SALES_TEMP_DATA_ERROR`

export const DELETE_SALES_TEMP_DATA = `${url}/DELETE_SALES_TEMP_DATA`
export const DELETE_SALES_TEMP_DATA_SUCCESS = `${url}/DELETE_SALES_TEMP_DATA_SUCCESS`
export const DELETE_SALES_TEMP_DATA_ERROR = `${url}/DELETE_SALES_TEMP_DATA_ERROR`

export const LOAD_BANK_DETAILS = `${url}/LOAD_BANK_DETAILS`
export const LOAD_BANK_DETAILS_SUCCESS = `${url}/LOAD_BANK_DETAILS_SUCCESS`
export const LOAD_BANK_DETAILS_ERROR = `${url}/LOAD_BANK_DETAILS_ERROR`

//Approval Sales Qc
export const APPROVE_SALES_QC_REQUEST = `${url}/APPROVE_SALES_QC_REQUEST`
export const APPROVE_SALES_QC_REQUEST_SUCCESS = `${url}/APPROVE_SALES_QC_REQUEST_SUCCESS`
export const APPROVE_SALES_QC_REQUEST_ERROR = `${url}/APPROVE_SALES_QC_REQUEST_ERROR`

export const UPDATE_SALES_QC_REAPPROVE = `${url}/UPDATE_SALES_QC_REAPPROVE`
export const UPDATE_SALES_QC_REAPPROVE_SUCCESS = `${url}/UPDATE_SALES_QC_REAPPROVE_SUCCESS`
export const UPDATE_SALES_QC_REAPPROVE_ERROR = `${url}/UPDATE_SALES_QC_REAPPROVE_ERROR`

export const LOAD_SALES_PENDING = `${url}/LOAD_SALES_PENDING`
export const LOAD_SALES_PENDING_SUCCESS = `${url}/LOAD_SALES_PENDING_SUCCESS`
export const LOAD_SALES_PENDING_ERROR = `${url}/LOAD_SALES_PENDING_ERROR`

export const LOAD_SALES_QC_HISTORY = `${url}/LOAD_SALES_QC_HISTORY`
export const LOAD_SALES_QC_HISTORY_SUCCESS = `${url}/LOAD_SALES_QC_HISTORY_SUCCESS`
export const LOAD_SALES_QC_HISTORY_ERROR = `${url}/LOAD_SALES_QC_HISTORY_ERROR`

//Sales preview

export const BOOKING_COMPLETE = `${url}/BOOKING_COMPLETE`
export const BOOKING_COMPLETE_SUCCESS = `${url}/BOOKING_COMPLETE_MASTER_SUCCESS`
export const BOOKING_COMPLETE_ERROR = `${url}/BOOKING_COMPLETE_ERROR`

// export const LOAD_SALES_PREVIEW_SEGMENT = `${url}/LOAD_SALES_PREVIEW_SEGMENT`
// export const LOAD_SALES_PREVIEW_SEGMENT_SUCCESS = `${url}/LOAD_SALES_PREVIEW_SEGMENT_SUCCESS`
// export const LOAD_SALES_PREVIEW_SEGMENT_ERROR = `${url}/LOAD_SALES_PREVIEW_SEGMENT_ERROR`

const constants = {
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_RECORDS_VALID_CACHE,

  //Sales add and list
  LOAD_SALES_DATA,
  LOAD_SALES_DATA_SUCCESS,
  LOAD_SALES_DATA_ERROR,

  CREATE_SALES_DATA,
  CREATE_SALES_DATA_SUCCESS,
  CREATE_SALES_DATA_ERROR,

  UPDATE_SALES_DATA,
  UPDATE_SALES_DATA_SUCCESS,
  UPDATE_SALES_DATA_ERROR,

  UPDATE_EVENT_DATA,
  UPDATE_EVENT_DATA_SUCCESS,
  UPDATE_EVENT_DATA_ERROR,

  //Sales temp add and list
  LOAD_SALES_TEMP_DATA,
  LOAD_SALES_TEMP_DATA_SUCCESS,
  LOAD_SALES_TEMP_DATA_ERROR,

  CREATE_SALES_TEMP_DATA,
  CREATE_SALES_TEMP_DATA_SUCCESS,
  CREATE_SALES_TEMP_DATA_ERROR,

  UPDATE_SALES_TEMP_DATA,
  UPDATE_SALES_TEMP_DATA_SUCCESS,
  UPDATE_SALES_TEMP_DATA_ERROR,

  DELETE_SALES_TEMP_DATA,
  DELETE_SALES_TEMP_DATA_SUCCESS,
  DELETE_SALES_TEMP_DATA_ERROR,

  LOAD_BANK_DETAILS,
  LOAD_BANK_DETAILS_SUCCESS,
  LOAD_BANK_DETAILS_ERROR,

  //Sales approve

  APPROVE_SALES_QC_REQUEST,
  APPROVE_SALES_QC_REQUEST_SUCCESS,
  APPROVE_SALES_QC_REQUEST_ERROR,

  UPDATE_SALES_QC_REAPPROVE,
  UPDATE_SALES_QC_REAPPROVE_SUCCESS,
  UPDATE_SALES_QC_REAPPROVE_ERROR,

  LOAD_SALES_PENDING,
  LOAD_SALES_PENDING_SUCCESS,
  LOAD_SALES_PENDING_ERROR,

  LOAD_SALES_QC_HISTORY,
  LOAD_SALES_QC_HISTORY_SUCCESS,
  LOAD_SALES_QC_HISTORY_ERROR,


  // //Sales preview details
  BOOKING_COMPLETE,
  BOOKING_COMPLETE_SUCCESS,
  BOOKING_COMPLETE_ERROR,

  // LOAD_SALES_PREVIEW_SEGMENT,
  // LOAD_SALES_PREVIEW_SEGMENT_SUCCESS,
  // LOAD_SALES_PREVIEW_SEGMENT_ERROR,
}

export default constants
